import { r as registerInstance, h, H as Host } from './index-68a8e4da.js';
var cardComponentCss = ".card-component{min-height:48px;padding:24px;color:rgba(0, 0, 0, 0.85);font-weight:500;background:#fff;zoom:1;height:100%;width:100%;border-radius:12px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:13px;color:#000}";
var CardComponent = /** @class */ (function () {
    function CardComponent(hostRef) {
        registerInstance(this, hostRef);
    }
    CardComponent.prototype.render = function () {
        return (h(Host, { class: "card-component" }, h("slot", null)));
    };
    return CardComponent;
}());
CardComponent.style = cardComponentCss;
export { CardComponent as card_component };
